module.exports = __webpack_public_path__ + "static/media/termopary9ru.0c4b3d84.pdf";